import { get, set, trimEnd } from 'lodash';
import { EXPERIMENT_TOGGLE_POST_INDEX_SEO_SETTINGS, EXPERIMENT_BM_BLOG_SEO_SETTINGS, } from '@wix/communities-blog-experiments';
import { getPostSeoDescription, getPostAmpUrl, getCanonicalPostUrl } from '../selectors/post-seo-selectors';
import { getPostExcerpt, getPostCover } from '../selectors/post-selectors';
import { getSchemaEnabled } from '../selectors/app-data-selectors';
import { getImageUrl } from './image-utils';
import { getVideoHost } from '../store';
import { isExperimentEnabled } from '../selectors';
var getPostFlattenedCategories = function (post, categoryMap) {
    return post.categoryIds
        .map(function (id) { return categoryMap[id]; })
        .filter(Boolean)
        .map(function (_a) {
        var label = _a.label;
        return label;
    })
        .join(', ');
};
var getTranslatedPagesData = function (translations) {
    return translations.map(function (translation) { return ({
        langCode: translation.language,
        url: "" + translation.url.base + translation.url.path,
        seoData: translation.seoData,
    }); });
};
export var generatePostPageSEOTags = function (_a) {
    var appConfig = _a.appConfig, post = _a.post, state = _a.state, categoriesMap = _a.categoriesMap, isMultilingualEnabled = _a.isMultilingualEnabled;
    var postPageSectionUrl = appConfig.postPageSectionUrl, ampBaseUrl = appConfig.ampBaseUrl, publisher = appConfig.publisher, imageHost = appConfig.imageHost;
    var slug = post.slug, seoDescription = post.seoDescription, title = post.title, seoTitle = post.seoTitle, lastPublishedDate = post.lastPublishedDate, firstPublishedDate = post.firstPublishedDate, owner = post.owner;
    var itemData = {
        post: {
            title: title,
            description: getPostSeoDescription(post),
            amphtml: getPostAmpUrl(post._id, ampBaseUrl, slug),
            type: 'article',
            canonicalUrl: getCanonicalPostUrl({ post: post, postPageSectionUrl: postPageSectionUrl }),
            optInMeta: 'max-snippet:-1, max-image-preview:large, max-video-preview:-1',
            slug: slug,
            excerpt: getPostExcerpt(post),
            lastPublishedDate: lastPublishedDate,
            firstPublishedDate: firstPublishedDate,
            categories: getPostFlattenedCategories(post, categoriesMap),
            owner: {
                name: owner.name,
            },
            path: trimEnd(postPageSectionUrl, '/') + "/" + post.slug,
        },
        legacySeoData: {
            title: seoTitle,
            description: seoDescription,
        },
        postsSettings: {
            isAmpEnabled: Boolean(ampBaseUrl),
            isSchemaEnabled: isExperimentEnabled(state, EXPERIMENT_BM_BLOG_SEO_SETTINGS) ||
                Boolean(appConfig.isWP || getSchemaEnabled(state)),
        },
    };
    if (isMultilingualEnabled && get(post, 'translations.length')) {
        itemData.translatedPages = getTranslatedPagesData(post.translations);
    }
    if (owner.image) {
        set(itemData, 'post.owner.image.url', typeof owner.image === 'string' ? owner.image : getImageUrl({ imageHost: imageHost, image: owner.image }));
    }
    if (publisher) {
        itemData.publisher = {
            id: publisher['@id'],
            name: publisher.name,
            logo: get(publisher, 'logo.url'),
        };
    }
    var isTogglePostIndexSEOExperimentEnabled = isExperimentEnabled(state, EXPERIMENT_TOGGLE_POST_INDEX_SEO_SETTINGS);
    var isPostShownInSearch = get(post, 'seoShowInSearch', true);
    if (isTogglePostIndexSEOExperimentEnabled) {
        if (!isPostShownInSearch) {
            itemData.post.noIndex = true;
        }
    }
    var _b = getPostCover(post, imageHost, getVideoHost(state)), shouldRender = _b.shouldRender, imageMetadata = _b.imageMetadata, videoMetadata = _b.videoMetadata;
    if (shouldRender) {
        itemData.post.image = {
            url: imageMetadata ? getImageUrl({ imageHost: imageHost, image: imageMetadata }) : videoMetadata.thumbnail_url,
            width: imageMetadata ? imageMetadata.width : videoMetadata.thumbnail_width,
            height: imageMetadata ? imageMetadata.height : videoMetadata.thumbnail_height,
        };
    }
    return itemData;
};
